export default __webpack_public_path__ + "static/Floorplan_for download_Villa-614fe046a34a771ab02cc1eca60c1e6d.pdf";